<template>
  <section id="portbanner">
    <div
      class="container d-flex align-items-center justify-content-center"
    >
      <div class="row">
        <div class="col-md-6 d-flex flex-column justify-content-center text-left">
          <i
            data-aos="fade-in"
            data-aos-duration="1500"
            :class="bannerContent.fontawesomeclass"
          ></i>

          <h1 class="line-1 anim-typewriter" v-html="bannerContent.title"></h1>
          <h3 v-html="bannerContent.name"></h3>

          <p
            data-aos="fade-in"
            data-aos-duration="1500"
            v-html="bannerContent.subtitle"
          ></p>
        </div>
        <div class="col-md-6">
          <img data-aos="fade" data-aos-duration="1500" :src="bannerContent.img" alt="port-img" width="100"/>
          <br />
          
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "portbanner",
  props: ["banner-content"],

  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/styles/_website.scss";
#portbanner {
  background-image: url("../assets/img/banner.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  .container {
    height: 70vh;
    @media screen and (max-width: 1366px), screen and (max-height: 687px) {
      height: 90vh;
    }
    h1 {
      color: $dirty-white;
      font-weight: bold;
      @media only screen and (max-width: 568px) {
        font-size: 9vw;
      }
    }
    h3 {
      color: $dirty-white;
    }
    p {
      color: $dirty-white;
          text-shadow: 1px 1px #000000;
    }
    img {
      height: auto;
      width: 70%;
      padding-bottom: 2%;
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
    }

    i {
      color: $dirty-white;
      font-size: 2rem;
    }
  }
  .line-1 {
    position: relative;
    border-right: 2px solid rgba(255, 255, 255, 0.75);
    
    white-space: nowrap;
    overflow: hidden;
  }

  /* Animation */
  .anim-typewriter {
    animation: typewriter 3s steps(30) 0.5s 1 normal both,
      blinkTextCursor 500ms steps(30) infinite normal;
  }
  @keyframes typewriter {
    from {
      width: 0;
    }
    to {
      width: 8em;
    }
  }
  @keyframes blinkTextCursor {
    from {
      border-right-color: rgba(255, 255, 255, 0.75);
    }
    to {
      border-right-color: transparent;
    }
  }
}
</style>